package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.GET_BAG_DETAILS
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class GetBagDetailsRequestModel(
    val bagId: Long
) : BaseRequestModel(api = GET_BAG_DETAILS)

